import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { AccountResponseDto, AccountsApi } from '@core/api/generated/accounts/v1';
import { Store } from '@ngrx/store';
import { loadUser } from '@store/actions/user.actions';
import { IAppState } from '@store/app.state';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';

export const userResolver: ResolveFn<Promise<AccountResponseDto>> = async (): Promise<AccountResponseDto> => {
    const accountApi = inject(AccountsApi);
    const store = inject(Store<IAppState>);
    const router = inject(Router);
    // if ('setup_intent' in route.queryParams && route.routeConfig?.path?.includes('dashboard')) {
    //     await new Promise((resolve) => setTimeout(resolve, 2000)); //Wait for stripe hook to our api
    // }
    // console.log('userResolver', route);
    // console.log('userResolver', state);
    const currentNavigation = router.getCurrentNavigation();
    const fragment = currentNavigation?.initialUrl.fragment;
    if (fragment?.includes('access_token')) {
        const token = fragment.split('access_token=')[1];
        localStorage.setItem('token', token.split('&')[0]);
    }
    const user: AccountResponseDto = await firstValueFrom(accountApi.getUser());
    store.dispatch(loadUser({ user }));
    // const { status } = user;
    // if (status === 'PENDING_ACCEPT_TERMS_AND_CONDITIONS') {
    //     router.navigate(['registration/sign-terms-policy']);
    // } else if (status === 'PENDING_REVIEW_USER_INFO') {
    //     router.navigate(['registration/confirm-account']);
    // }
    return user;
};
